import React, { useCallback, useEffect, useState } from 'react'
import _debounce from 'lodash.debounce'
import { useSelector } from 'react-redux'

import './styles.scss'
import { intranetApi } from 'api'
import FiltersSection from './FiltersSection'
import ResultsSection from './ResultsSection'
import { lang } from 'utils/helpers'

const TranslationsSection = () => {
  const operatorLocale = useSelector(store => store.user?.locale)
  const [translations, setTranslations] = useState([])
  const [labelsOptions, setLabelsOptions] = useState([])
  const [filters, setFilters] = useState({
    page: 0, pageSize: 30, platform: 'all',
    locale: operatorLocale || 'es'
  })
  const [loading, setLoading] = useState(true)
  const [isAll, setIsAll] = useState(false)

  useEffect(() => {
    getTranslations(filters)
    getLabels()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getTranslations = filters => {
    setLoading(true)

    intranetApi
      .translations.getTranslationsList(filters)
      .then(({ data }) => {
        if (filters.page > 0) {
          setTranslations(prevState => ([ ...prevState, ...data ]))
        } else {
          setTranslations(data)
        }
        if (data.length < filters.pageSize) {
          setIsAll(true)
        } else {
          setIsAll(false)
        }
      })
      .finally(() => setLoading(false))
  }

  const getLabels = () => {
    intranetApi.translations.getLabelsList({ pageSize: 100 })
      .then(({ data }) => {
        const labels = data.map(({ _id, name }) => ({ value: _id, label: name }))
        setLabelsOptions(labels)
      })
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleSearchTranslations = useCallback(_debounce(filter => getTranslations(filter), 250), [])

  const handleOnChangeFilters = filter => {
    setFilters(filter)
    handleSearchTranslations(filter)
  }

  return (
    <div className='translations-translations-section'>
      <div className='translations-translations-section__header'>
        <p className='translations-translations-section__title'>
          {lang('dashboard_translations')}
        </p>
        <p className='translations-translations-section__description'>
          {lang('dashboard_manage-platforms-translations')}
        </p>
      </div>
      <div className='translations-translations-section__body'>
        <FiltersSection
          labelsOptions={labelsOptions}
          selectedLocale={filters.locale}
          onChange={handleOnChangeFilters}
        />
        <ResultsSection
          filters={filters}
          setFilters={setFilters}
          getTranslations={getTranslations}
          translations={translations}
          setTranslations={setTranslations}
          labelsOptions={labelsOptions}
          loading={loading}
          isAllTranslations={isAll}
        />
      </div>
    </div>
  )
}

export default TranslationsSection
